import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CalendarComponent from "../../calendar/calendarComponent";
import { CustomPropertyDate, CustomPropertyInputItem } from "ui/CustomProperty";
import { formatter } from "app/utils";
import { CPDateTypeProps } from "../types";
import moment from "moment";

const DateCustomProp: React.FC<CPDateTypeProps> = ({
  name,
  codeName,
  required,
  permissions,
  isWidget,
  tabIndex,
  onChange,
  value,
  customPropertyId,
  keyId,
  parentKey,
  isError
}) => {
  const { t, i18n } = useTranslation();
  const [valid, setValid] = useState(true);
  const [isOpenDate, setOpenDate] = useState(false);

  useEffect(() => {
    if (isError !== undefined && required) {
      setValid(!isError);
    }
  }, [isError]);

  const validate = (checkedValue: Date | null): boolean => {
    const isValid = !required || !!checkedValue;
    setValid(isValid);
    return isValid;
  };

  const toggleDatePicker = () => {
    setOpenDate(!isOpenDate);
  };

  const onSelectDate = (selectedDate: any) => {
    toggleDatePicker();
    const formattedDate = formatter("DD.MM.YYYY", i18n.language, selectedDate);
    onChange({
      customPropertyCode: codeName,
      value: 0,
      customPropertyId: String(customPropertyId),
      text: formattedDate,
      key: keyId,
      parentKey: parentKey,
    });
    validate(selectedDate);
  };

  const isDisabled = permissions.includes(codeName);

  return (
    <CustomPropertyInputItem
      isWidget={!!isWidget}
      valid={valid}
      name={name}
      required={required}
      disabled={isDisabled}
    >
      <CustomPropertyDate
        isWidget={!!isWidget}
        value={
          value?.text
            ? formatter(
                "DD.MM.YYYY",
                i18n.language,
                moment(value.text, "DD.MM.YYYY").toDate()
              )
            : ""
        }
        onClick={toggleDatePicker}
        tabIndex={tabIndex}
        disabled={isDisabled}
      />
      <CalendarComponent
        startDate={
          value?.text ? moment(value.text, "DD.MM.YYYY").toDate() : undefined
        }
        isMultiChoice={false}
        isShown={isOpenDate}
        onSelected={onSelectDate}
        month={
          value?.text ? moment(value.text, "DD.MM.YYYY").toDate() : undefined
        }
        onClose={toggleDatePicker}
      />
    </CustomPropertyInputItem>
  );
};

export default DateCustomProp;
